import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";

type MenuItem = {
  fr: string;
  en: string;
  prixFr: string;
  prixEn: string;
  descFr: string;
  descEn: string;
};

const MenuListItem = ({ fr, en, prixFr, prixEn, descFr, descEn, language }: any) => (
  <li className="border-b border-gray-200 pb-6 last:border-0">
    <div className="flex justify-between items-start">
      <div>
        <h3 className="font-bold text-xl">{language === "fr" ? fr : en}</h3>
        <p className="text-gray-600 mt-1 text-sm">{language === "fr" ? descFr : descEn}</p>
      </div>
      <span className="text-green-950 font-medium text-lg whitespace-nowrap ml-4">
        {language === "fr" ? prixFr : prixEn}
      </span>
    </div>
  </li>
);

const EntreesDinner = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => navigate("/MainDinner"),
    onSwipedRight: () => navigate("/DrinksDinner"),
    trackMouse: true,
    delta: 50,
    trackTouch: true,
  });

  const renderMenuList = (items: MenuItem[]) => (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-4xl w-full shadow-lg mt-8">
      <ul className="space-y-6">
        {items.map((item, index) => (
          <MenuListItem key={index} {...item} language={language} />
        ))}
      </ul>
    </div>
  );

  // ====== DATA ======
  const dinnerEntrees: MenuItem[] = [
    {
      fr: "Hummus",
      en: "Hummus",
      prixFr: "8$",
      prixEn: "$8",
      descFr:
        "Crème onctueuse à base de pois chiches, ail et huile d'olive, garnie de noix de Grenoble et de graines de sésame.",
      descEn:
        "Creamy spread made with chickpeas, garlic, and olive oil, topped with walnuts and sesame seeds.",
    },
    {
      fr: "Hmiss",
      en: "Hmiss",
      prixFr: "10$",
      prixEn: "$10",
      descFr:
        "Délicieuse préparation à base de poivrons grillés, tomates, ail et épices, relevée d'une touche d'huile d'olive.",
      descEn:
        "Delicious spread made from roasted peppers, tomatoes, garlic, and spices, enhanced with a drizzle of olive oil.",
    },
    {
      fr: "Mini tarte tatin salée",
      en: "Mini salty tarte tatin",
      prixFr: "10$",
      prixEn: "$10",
      descFr:
        "Deux mini tartes tatin salées garnies de tomates et d’échalotes caramélisées, pour un équilibre parfait entre douceur et salinité.",
      descEn:
        "Two savory mini tartes tatin topped with caramelized tomatoes and shallots, offering a perfect balance of sweet and salty flavors.",
    },
    {
      fr: "Bourek",
      en: "Bourek",
      prixFr: "10$",
      prixEn: "$10",
      descFr:
        "Trois rouleaux de pâte feuilletée croustillante, farcis au choix : viande savoureuse ou version végétarienne aux épinards et fromage fondant.",
      descEn:
        "Three crispy puff pastry rolls, filled with your choice of savory meat or a vegetarian blend of spinach and melting cheese.",
    },
  ];

  return (
    <div
      {...handlers}
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {renderMenuList(dinnerEntrees)}
    </div>
  );
};

export default EntreesDinner;
